import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import TableSkeleton from "../../Reuseable/TableSkeleton";
import { Link, useNavigate } from "react-router-dom";
import { Tooltip, message } from "antd";
import DataParser from "../../../utlits/Dataparser";
import CommunicationsServices from "../../../Services/CommunicationsServices";
import secureLocalStorage from "react-secure-storage";
import { paginate } from "../../../utlits/Paginate.js";
import Pagination from "../../Reuseable/Pagination";
import StatusBadge from "../../Reuseable/StatusBadge";

message.config({ zIndex: 1000000001 });

const Communication = () => {
  const [CommunicationList, setCommunicationList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [userPermissions, setuserPermissions] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [communicationName, setCommunicationName] = useState("");
  const [communicationType, setCommunicationType] = useState("inbound");
  const [communicationEditName, setCommunicationEditName] = useState("");
  const [communicationEditType, setCommunicationEditType] = useState("inbound");
  const [error, setError] = useState("");
  const [editValue, setEditValue] = useState(null);
  const [itemToDelete, setItemToDelete] = useState(null);

  const companyId = DataParser.CompanyId();
  const navigate = useNavigate();

  const getData = () => {
    setLoading(true);
    CommunicationsServices.getCommunicationsServices(companyId)
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          message.error("Session expired! Please log in again.");
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
          return;
        }
        const data = res.data.communications || [];
        setCommunicationList(data);
      })
      .catch((err) => {
        console.error("Error fetching lead sources:", err);
        message.error("Failed to load lead sources. Please try again!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getData();
    const upermission = DataParser.CompanyUserPermissions();
    setuserPermissions(upermission);
  }, []);

  useEffect(() => {
    if (pageSize > 15) setCurrentPage(1);
  }, [pageSize]);

  const handelPageChange = (e, page) => {
    e.preventDefault();
    setCurrentPage(page);
  };

  const clearCreateState = () => {
    setCommunicationName("");
    setError("");
  };

  const clearEditState = () => {
    setCommunicationEditName("");
    setEditValue(null);
    setError("");
  };

  const handelSubmit = (e) => {
    e.preventDefault();

    if (communicationName.trim() === "") {
      setError("Lead source name is required!");
      return;
    }

    CommunicationsServices.createCommunications({ name: communicationName.trim(), company_id: companyId })
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          message.error("Session expired! Please log in again.");
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
        } else if (res.Good === true) {
          message.success("Lead source created successfully!");
          const link = document.getElementById("closeCreateCommunication");
          if (link) link.click();
          setCommunicationName("");
          getData();
        } else {
          message.warning("Could not create lead source. Please try again!");
        }
      })
      .catch((err) => {
        console.error("Create error:", err);
        message.error(
          err.response?.data?.message || "An error occurred while creating the lead source."
        );
      });
  };

  const handleOpenUpdate = (e, item) => {
    e.preventDefault();
    setCommunicationEditName(item.value);
    setEditValue(item);
    setError("");
  };

  const handelEditSubmit = (e) => {
    e.preventDefault();

    if (communicationEditName.trim() === "") {
      setError("Lead source name is required!");
      return;
    }

    const id = editValue.id;
    CommunicationsServices.editCommunication(id, { name: communicationEditName.trim() })
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          message.error("Session expired! Please log in again.");
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
        } else if (res.Good === true) {
          message.success("Lead source updated successfully!");
          const link = document.getElementById("closeEditCommunication");
          if (link) link.click();
          setCommunicationEditName("");
          getData();
        } else {
          message.warning("Could not update lead source. Please try again!");
        }
      })
      .catch((err) => {
        console.error("Update error:", err);
        message.error(
          err.response?.data?.message || "An error occurred while updating the lead source."
        );
      });
  };

  const handelDelete = (e, item) => {
    e.preventDefault();
    setItemToDelete(item);
    document.getElementById("openDeleteCommunicationModal").click();
  };

  const confirmDelete = async () => {
    if (!itemToDelete) return;
    const id = itemToDelete.id;
    setCommunicationList((prev) => prev.filter((el) => el.id !== id));
    document.getElementById("closeDeleteCommunicationModal").click();
    try {
      const res = await CommunicationsServices.deleteCommunicationsServices(id, companyId);
      if (res.data === "Un-Athunticated request") {
        secureLocalStorage.removeItem("adminInfo");
        secureLocalStorage.removeItem("admins");
        navigate("/");
      } else {
        message.success("Lead source deleted successfully!");
      }
      getData();
    } catch (err) {
      console.error("Delete error:", err);
      message.error("Failed to delete lead source. Please try again!");
      getData();
    }
    setItemToDelete(null);
  };

  const PaginatedData = paginate(CommunicationList, currentPage, pageSize);

  return (
    <>
      <Helmet>
        <title>Lead Source - Planit</title>
      </Helmet>
      <div className="main-content">
        <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 px-0">
                <div className="d-flex align-items-end justify-content-end" style={{ padding: "0 0 12px 0" }}>
                  <div className="d-flex flex-column align-items-end" style={{ gap: "6px" }}>
                    <ol className="breadcrumb mb-0">
                      <li className="breadcrumb-item">
                        <Link to={`/${DataParser.CompanyIdentifierRole()}/employee-attendance`}>Home</Link>
                      </li>
                      <li className="breadcrumb-item active">
                        <Link to={`/${DataParser.CompanyIdentifierRole()}/settings`}>Settings</Link>
                      </li>
                      <li className="breadcrumb-item active">Lead Source</li>
                    </ol>
                    {userPermissions.indexOf("communicationsource-create") !== -1 ? (
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        style={{ borderRadius: "5px" }}
                        data-bs-toggle="modal"
                        data-bs-target="#createCommunicationModalDialog"
                      >
                        Create Lead Source
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        disabled
                        style={{ opacity: 0.6, cursor: "not-allowed", borderRadius: "5px" }}
                      >
                        Create Lead Source
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-lg-12 px-0">
                <div className="card" style={{ backgroundColor: "#fff", boxShadow: "none", borderRadius: 0, border: "none" }}>
                  <div className="card-body p-0">
                    <div className="table-responsive listing-table-wrapper">
                      <table className="table mb-0 custom-table listing-table">
                        <thead>
                          <tr className="tableHeaderbg">
                            <th>Sr#</th>
                            <th>Lead Source Name</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading ? (
                            <TableSkeleton cols={4} rows={6} />
                          ) : PaginatedData && PaginatedData.length > 0 ? (
                            PaginatedData.map((item, index) => (
                              <tr key={item.id}>
                                <td>{index + 1}</td>
                                <td>{item.value}</td>
                                <td>
                                  {userPermissions.indexOf("communicationsource-edit") !== -1 ? (
                                    <StatusBadge
                                      item={item}
                                      api={CommunicationsServices.statusChange}
                                    />
                                  ) : (
                                    <>
                                      {item.status === "1" ? (
                                        <span className="badge bg-success text-white">Active</span>
                                      ) : (
                                        <span className="badge bg-danger text-white">Deactive</span>
                                      )}
                                    </>
                                  )}
                                </td>
                                <td className="tableset">
                                  {userPermissions.indexOf("communicationsource-delete") !== -1 ? (
                                    <Link
                                      to="#"
                                      className="cursor-pointer iconscolor"
                                      onClick={(e) => handelDelete(e, item)}
                                    >
                                      <Tooltip title="Delete Lead Source">
                                        <i className="uil-trash iconscolor" />
                                      </Tooltip>
                                    </Link>
                                  ) : (
                                    <span
                                      className="uil-trash iconscolor text-muted"
                                      style={{ cursor: "not-allowed", opacity: 0.5 }}
                                      title="You don't have permission to delete"
                                    />
                                  )}
                                  {userPermissions.indexOf("communicationsource-edit") !== -1 ? (
                                    <Link
                                      to="#"
                                      className="cursor-pointer iconscolor"
                                      onClick={(e) => handleOpenUpdate(e, item)}
                                      data-bs-toggle="modal"
                                      data-bs-target="#editCommunicationModalDialog"
                                    >
                                      <Tooltip title="Edit Lead Source">
                                        <i className="uil-pen iconscolor" />
                                      </Tooltip>
                                    </Link>
                                  ) : (
                                    <span
                                      className="uil-pen iconscolor text-muted"
                                      style={{ cursor: "not-allowed", opacity: 0.5 }}
                                      title="You don't have permission to edit"
                                    />
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center">
                                Add your first lead source by clicking the 'Create Lead Source' button.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>

                      {CommunicationList.length > pageSize && (
                        <div className="d-flex justify-content-center mt-4">
                          <Pagination
                            itemCount={CommunicationList.length}
                            currentPage={currentPage}
                            pageSize={pageSize}
                            onPageChange={handelPageChange}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Hidden trigger for delete modal */}
        <div id="openDeleteCommunicationModal" data-bs-toggle="modal" data-bs-target="#deleteCommunicationModal" style={{ display: "none" }} />

        {/* Delete Confirmation Modal */}
        <div id="deleteCommunicationModal" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true" data-bs-keyboard="false">
          <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
            <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
              <div className="modal-header border-0 pb-1">
                <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Delete Lead Source</h5>
                <button type="button" className="btn-close" id="closeDeleteCommunicationModal" data-bs-dismiss="modal" aria-label="Close" onClick={() => setItemToDelete(null)} />
              </div>
              <div className="modal-body pt-2 pb-2">
                <p style={{ fontSize: "14px", color: "#1D1D1D", marginBottom: "6px" }}>Are you sure you want to delete this lead source?</p>
                <p style={{ fontSize: "13px", color: "#ff4d4f", marginBottom: 0 }}>
                  <i className="uil uil-exclamation-triangle me-1" />
                  This action cannot be undone.
                </p>
              </div>
              <div className="modal-footer border-0 pt-1">
                <button type="button" className="btn btn-danger waves-effect waves-light" onClick={confirmDelete} style={{ borderRadius: "5px", fontSize: "13px" }}>
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Create Modal */}
        <div
          id="createCommunicationModalDialog"
          className="modal fade"
          tabIndex={-1}
          role="dialog"
          aria-hidden="true"
          data-bs-keyboard="false"
        >
          <form onSubmit={handelSubmit}>
            <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
              <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                <div className="modal-header border-0 pb-1">
                  <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Create Lead Source</h5>
                  <button
                    type="button"
                    className="btn-close"
                    id="closeCreateCommunication"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={clearCreateState}
                  />
                </div>
                <div className="modal-body pt-2 pb-2">
                  <div className="float-input-wrap">
                    <input
                      type="text"
                      className={error ? "is-invalid" : ""}
                      id="CommunicationName"
                      placeholder=" "
                      value={communicationName}
                      onChange={(e) => {
                        setCommunicationName(e.target.value);
                        if (e.target.value.trim() !== "") setError("");
                      }}
                    />
                    <label htmlFor="CommunicationName">Lead Source Name*</label>
                  </div>
                  {error && <small className="text-danger mt-1 d-block">{error}</small>}
                </div>
                <div className="modal-footer border-0 pt-1">
                  <button
                    type="button"
                    onClick={handelSubmit}
                    className="btn btn-primary waves-effect waves-light"
                    style={{ borderRadius: "5px", fontSize: "13px" }}
                  >
                    + Create Lead Source
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>

        {/* Edit Modal */}
        <div
          id="editCommunicationModalDialog"
          className="modal fade"
          tabIndex={-1}
          role="dialog"
          aria-hidden="true"
          data-bs-keyboard="false"
        >
          <form onSubmit={handelEditSubmit}>
            <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
              <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                <div className="modal-header border-0 pb-1">
                  <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Edit Lead Source</h5>
                  <button
                    type="button"
                    className="btn-close"
                    id="closeEditCommunication"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={clearEditState}
                  />
                </div>
                <div className="modal-body pt-2 pb-2">
                  <div className="float-input-wrap">
                    <input
                      type="text"
                      className={error ? "is-invalid" : ""}
                      id="CommunicationNameEdit"
                      placeholder=" "
                      value={communicationEditName}
                      onChange={(e) => {
                        setCommunicationEditName(e.target.value);
                        if (e.target.value.trim() !== "") setError("");
                      }}
                    />
                    <label htmlFor="CommunicationNameEdit">Lead Source Name*</label>
                  </div>
                  {error && <small className="text-danger mt-1 d-block">{error}</small>}
                </div>
                <div className="modal-footer border-0 pt-1">
                  <button
                    type="button"
                    onClick={handelEditSubmit}
                    className="btn btn-primary waves-effect waves-light"
                    style={{ borderRadius: "5px", fontSize: "13px" }}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Communication;
